module.exports = __webpack_public_path__ + "img/chapter__8_image_3.217cb7be.png";